module.exports = __webpack_public_path__ + "img/triangle2.f789704e.svg";